module.exports = __webpack_public_path__ + "static/media/Euro.8f276c67.svg";